export const spacesApiErrorsTranslations = {
  RESOURCE_ALREADY_EXISTS: 'spaces:createSpace.resourceAlreadyExists',
  OVERLAPPING_SPACE_BLOCKADE_EXISTS:
    'spaces:common.overlappingSpaceBlockadeExists',
  OVERLAPPING_SPACE_UNAVAILABILITY_PERIOD_EXISTS:
    'spaces:common.overlappingSpaceUnavailabilityPeriodExists',
  TOO_MANY_SPACES: 'spaces:common.tooManySpaces',
  FLOOR_IS_NOT_OWNED_BY_TENANT: 'spaces:common.floorIsNotOwnedByTenant',
} as const;
